import axios from 'axios';
import {
    VIDEO_CAMPAIGN_CREATE_FAIL,
    VIDEO_CAMPAIGN_CREATE_REQUEST,
    VIDEO_CAMPAIGN_CREATE_SUCCESS,
    VIDEO_CAMPAIGN_DELETE_FAIL,
    VIDEO_CAMPAIGN_DELETE_REQUEST,
    VIDEO_CAMPAIGN_DELETE_SUCCESS,
    VIDEO_CAMPAIGN_DETAIL_FAIL,
    VIDEO_CAMPAIGN_DETAIL_REQUEST,
    VIDEO_CAMPAIGN_DETAIL_SUCCESS,
    VIDEO_CAMPAIGN_LIST_FAIL,
    VIDEO_CAMPAIGN_LIST_REQUEST,
    VIDEO_CAMPAIGN_LIST_SUCCESS,
    VIDEO_CAMPAIGN_UPDATE_FAIL,
    VIDEO_CAMPAIGN_UPDATE_REQUEST,
    VIDEO_CAMPAIGN_UPDATE_SUCCESS,
} from '../constants/videoCampaignConstants';

export const listVideoCampaigns = () => async (dispatch, getState) => {
    try {
        dispatch({ type: VIDEO_CAMPAIGN_LIST_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const { data } = await axios.get(`/api/video_campaigns`, config);

        dispatch({ type: VIDEO_CAMPAIGN_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: VIDEO_CAMPAIGN_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const createVideoCampaign = (videoCampaign) => async (dispatch, getState) => {
    try {
        dispatch({ type: VIDEO_CAMPAIGN_CREATE_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(`/api/video_campaigns`, videoCampaign, config);

        dispatch({ type: VIDEO_CAMPAIGN_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: VIDEO_CAMPAIGN_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateVideoCampaign = (id, videoCampaign) => async (dispatch, getState) => {
    try {
        dispatch({ type: VIDEO_CAMPAIGN_UPDATE_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `/api/video_campaigns/${id}`,
            videoCampaign,
            config
        );

        dispatch({ type: VIDEO_CAMPAIGN_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: VIDEO_CAMPAIGN_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listVideoCampaignDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: VIDEO_CAMPAIGN_DETAIL_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        console.log('details list videoCampaign called');
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 10000,
        };
        const { data } = await axios.get(`/api/video_campaigns/${id}` ,config);
        dispatch({ type: VIDEO_CAMPAIGN_DETAIL_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: VIDEO_CAMPAIGN_DETAIL_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteVideoCampaign = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: VIDEO_CAMPAIGN_DELETE_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
            timeout: 10000,
        };
        const { data } = await axios.delete(`/api/video_campaigns/${id}`, config);
        dispatch({ type: VIDEO_CAMPAIGN_DELETE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: VIDEO_CAMPAIGN_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
